import SpecsContainer from "./SpecsContainer";
export default SpecsContainer;
